import { render } from "./SelecionarFornecedor.vue?vue&type=template&id=4d5f0abb&scoped=true&ts=true"
import script from "./SelecionarFornecedor.vue?vue&type=script&lang=ts"
export * from "./SelecionarFornecedor.vue?vue&type=script&lang=ts"

import "./SelecionarFornecedor.vue?vue&type=style&index=0&id=4d5f0abb&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5f0abb"]])

export default __exports__